import React from "react";
import "../assets/AtmabodhVatika.css";

const heroPoints = [
  "Foothills of Sinhagad",
  "Beside Atmabodh Wellness Centre",
  "3 Guntha Signature Plots",
  "Nature-Centric Resort Living",
  "Limited Premium Inventory",
];

const highlights = [
  "3 Guntha Spacious Plots",
  "9 & 12 Meter Internal Roads",
  "Solar Street Lighting",
  "Gated Community",
  "Nature Landscapes",
  "Wellness-Centric Planning",
];

const connectivity = [
  {
    place: "Kothrud",
    time: "25 mins",
  },
  {
    place: "Bavdhan",
    time: "30 mins",
  },
  {
    place: "Hinjewadi",
    time: "45 mins",
  },
  {
    place: "Khadakwasla",
    time: "Nearby",
  },
  {
    place: "Sinhagad Fort",
    time: "Nearby",
  },
];

export default function AtmabodhVatika() {
  return (
    <div className="av-container">
      {/* HERO SECTION */}
      <section className="av-hero-section">
        <div className="av-overlay"></div>

        <div className="av-hero-content">
          <p className="av-top-label">SAMRIDDHI GROUP PRESENTS</p>

          <h1 className="av-hero-title">
            Your Private Wellness Retreat
            <span>At The Foothills of Sinhagad</span>
          </h1>

          <p className="av-hero-subtitle">
            Own a nature centric wellness estate beside Atmabodh
            Wellness Centre.
          </p>

          <div className="av-tablets-grid">
            {heroPoints.map((item, index) => (
              <div className="av-tablet" key={index}>
                {item}
              </div>
            ))}
          </div>

          <div className="av-hero-buttons">
            <button className="av-primary-btn">
              Schedule A Private Tour
            </button>

            <button className="av-secondary-btn">
              Explore The Estate
            </button>
          </div>
        </div>
      </section>

      {/* OWN EXPERIENCE VALUE */}
      <section className="av-value-section">
        <div className="av-section-header">
          <p className="av-section-tag">A WELLNESS ESTATE EXPERIENCE</p>

          <h2>
            More Than Land.
            <span>A Lifestyle Asset Rooted In Wellness.</span>
          </h2>

          <p className="av-section-description">
            Crafted for those who seek personal wellness, nature-led
            living and long-term lifestyle value.
          </p>
        </div>

        <div className="av-value-grid">
          <div className="av-value-card">
            <div className="av-card-number">01</div>

            <h3>Own</h3>
            <p className="av-card-subtitle">
              Secure. Freehold. Timeless.
            </p>

            <ul>
              <li>Freehold NA bungalow plots</li>
              <li>Clear legal ownership</li>
              <li>Low-density premium planning</li>
              <li>Thoughtfully planned infrastructure</li>
              <li>Long-term lifestyle asset</li>
            </ul>
          </div>

          <div className="av-value-card">
            <div className="av-card-number">02</div>

            <h3>Experience</h3>
            <p className="av-card-subtitle">
              Calm. Nature. Rejuvenation.
            </p>

            <ul>
              <li>Nature-centric wellness living</li>
              <li>Resort-inspired environment</li>
              <li>Fresh air & open landscapes</li>
              <li>Wellness-focused surroundings</li>
              <li>Peaceful private lifestyle</li>
            </ul>
          </div>

          <div className="av-value-card">
            <div className="av-card-number">03</div>

            <h3>Value</h3>
            <p className="av-card-subtitle">
              Lifestyle Today. Appreciation Tomorrow.
            </p>

            <ul>
              <li>Located in Pune’s wellness belt</li>
              <li>High-demand second-home destination</li>
              <li>Limited signature plots</li>
              <li>Strong appreciation potential</li>
              <li>Premium lifestyle positioning</li>
            </ul>
          </div>
        </div>
      </section>

      {/* PROJECT HIGHLIGHTS */}
      <section className="av-highlights-section">
        <div className="av-section-header">
          <p className="av-section-tag">PROJECT HIGHLIGHTS</p>

          <h2>
            Thoughtfully Planned
            <span>For Elevated Living</span>
          </h2>
        </div>

        <div className="av-highlights-grid">
          {highlights.map((item, index) => (
            <div className="av-highlight-card" key={index}>
              <div className="av-highlight-circle"></div>
              <h4>{item}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* CONNECTIVITY */}
      <section className="av-connectivity-section">
        <div className="av-section-header">
          <p className="av-section-tag">CONNECTIVITY</p>

          <h2>
            Well Connected.
            <span>Yet Peacefully Away.</span>
          </h2>
        </div>

        <div className="av-connectivity-grid">
          {connectivity.map((item, index) => (
            <div className="av-connect-card" key={index}>
              <h3>{item.place}</h3>
              <p>{item.time}</p>
            </div>
          ))}
        </div>
      </section>

      {/* LOCATION EXPERIENCE */}
      <section className="av-location-section">
        <div className="av-location-overlay"></div>

        <div className="av-location-content">
          <p className="av-section-tag">THE SINHAGAD EXPERIENCE</p>

          <h2>
            The Place Punekars
            <span>Always Return To.</span>
          </h2>

          <p>
            Sinhagad has always been more than a destination.
            It’s where mornings feel lighter, conversations become
            longer and life slows down naturally.
          </p>

          <p>
            Atmabodh Vatika brings that feeling closer to everyday living.
          </p>
        </div>
      </section>

      {/* ENQUIRY */}
      <section className="av-enquiry-section">
        <div className="av-enquiry-left">
          <p className="av-section-tag">BEGIN YOUR JOURNEY</p>

          <h2>
            Begin Your Wellness
            <span>Living Journey</span>
          </h2>

          <p>
            Schedule a private presentation and site experience with
            our team.
          </p>
        </div>

        <div className="av-form-wrapper">
          <form className="av-form">
            <input type="text" placeholder="Your Name" />
            <input type="tel" placeholder="Phone Number" />
            <input type="email" placeholder="Email Address" />
            <input type="text" placeholder="Preferred Visit Date" />

            <button type="submit" className="av-primary-btn av-full-btn">
              Request A Private Tour
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

